// SSE уведомлений пользователя: realtime шлёт событие notification после каждой новой записи,
// открытая вкладка перечитывает счётчик и список. EventSource не умеет заголовки, поэтому
// access-токен уходит в query; realtime проверяет его по JWKS auth.
import { useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { tokenStore } from "@/api/client";
import { moreKeys } from "@/api/queries";

export function useNotificationsStream(enabled: boolean) {
  const qc = useQueryClient();
  const token = tokenStore.get();
  useEffect(() => {
    if (!enabled || !token || typeof EventSource === "undefined") return;
    const es = new EventSource(`/api/v1/live/me?access_token=${encodeURIComponent(token)}`);
    es.addEventListener("notification", () => {
      qc.invalidateQueries({ queryKey: moreKeys.unread });
      qc.invalidateQueries({ queryKey: moreKeys.notifications });
    });
    return () => es.close();
  }, [enabled, token, qc]);
}
